import React from 'react';
import { useLogin } from '../hooks/useLogin';

const LoginLabel = () => {
	const { iconLabel } = useLogin();

	return (
		<div
			className=" vtex-button__label flex items-center justify-center h-100 ph6"
			style={{
				paddingTop: '0.25em',
				paddingBottom: '0.32em',
			}}
		>
			<span className="flex items-center nl2">
				<div>
					<div className="flex pv2 items-center">
						<span className="vtex-login-2-x-label label t-action--smallpl4 gray dn db-l">{iconLabel}</span>
					</div>
				</div>
			</span>
		</div>
	);
};

export default LoginLabel;
